module.exports = __webpack_public_path__ + "img/beachUmbrellaWithCover.f43a2b9a.svg";